import { GeneratePayrun } from "@xemplo/generate-payrun";
import styled from "styled-components";
import { useIsUserInRole } from "../../../hooks";
import { PersonaRole } from "@xemplo/gp-types";

interface GeneratePayrunButtonProps {
  payScheduleId?: string;
  onPayrunGenerationCallback?: () => void;
}

export function GeneratePayrunButton(
  props: Readonly<GeneratePayrunButtonProps>
) {
  const userHasPermission = useIsUserInRole([
    PersonaRole.PSPAdmin,
    PersonaRole.SystemAdmin,
    PersonaRole.PayrollManager,
  ]);
  if (!userHasPermission) {
    return null;
  }
  return (
    <Wrapper>
      <GeneratePayrun
        payScheduleId={props?.payScheduleId}
        onSuccessCallback={props.onPayrunGenerationCallback}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  align-items: flex-end;
`;
